'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.authenticatedFetch = authenticatedFetch;
exports.authenticatedFetchRaw = authenticatedFetchRaw;
exports.unauthenticatedFetchRaw = unauthenticatedFetchRaw;
exports.authenticatedFetchBlob = authenticatedFetchBlob;
exports.authenticatedFetchJSON = authenticatedFetchJSON;
exports.getAuthenticatedFetchBlob = getAuthenticatedFetchBlob;
exports.getAuthenticatedFetchJSON = getAuthenticatedFetchJSON;
exports.getAuthenticatedFetch = getAuthenticatedFetch;
exports.getAuthenticatedFetchRaw = getAuthenticatedFetchRaw;
exports.getUnauthenticatedFetchRaw = getUnauthenticatedFetchRaw;
exports.polyfillCustomEvent = polyfillCustomEvent;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _rioStorage = require('rio-storage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('es6-promise').polyfill();
require('isomorphic-fetch');

function FetchResponseError(response, body) {
    Error.call(this);
    this.name = 'FetchResponseError';
    this.message = response.statusText;
    this.status = response.status;
    this.body = body;
}

function ParseResponseError(message, rawString, url) {
    Error.call(this);
    this.name = 'ParseResponseError';
    this.message = message;
    this.rawString = rawString;
    this.url = url;
}

function validateFetch(fetch) {
    if (!fetch || !_lodash2.default.isFunction(fetch)) {
        throw new Error('fetch needs to be injected');
    }
}

function validateDocument(document) {
    if (!document || !document.dispatchEvent || !_lodash2.default.isFunction(document.dispatchEvent)) {
        throw new Error('document needs to be injected');
    }
}

function fixRequestObject(requestObject) {
    if (!_lodash2.default.isObject(requestObject)) {
        return {};
    }

    return requestObject;
}

function enrichRequestObject(requestObject) {
    var accessToken = (0, _rioStorage.getStorageUtils)().getSessionToken();

    var authorizationBearer = 'Bearer ' + accessToken;

    requestObject = fixRequestObject(requestObject);

    if (typeof requestObject.headers === 'undefined') {
        requestObject.headers = {
            'Authorization': authorizationBearer
        };
    } else {
        requestObject.headers['Authorization'] = authorizationBearer;
    }

    return requestObject;
}

function parseRequestObjectBody(requestObject) {

    requestObject = fixRequestObject(requestObject);

    if (requestObject && _lodash2.default.isObject(requestObject.body)) {
        requestObject.body = JSON.stringify(requestObject.body);
    }

    return requestObject;
}

function rejectResponse(response, injectedDocument) {
    if (response.text) {
        return response.text().then(function (message) {
            var error = new FetchResponseError(response, message);
            var event = new CustomEvent('FetchResponseError', { detail: error });
            injectedDocument.dispatchEvent(event);

            return Promise.reject(error);
        });
    } else {
        var error = new FetchResponseError(response, '');
        var event = new CustomEvent('FetchResponseError', { detail: error });
        injectedDocument.dispatchEvent(event);

        return Promise.reject(error);
    }
}

function handleTextResponse(response, injectedDocument) {
    if (response.ok) {
        return response.text().then(function (message) {
            return Promise.resolve(message);
        });
    } else {
        return rejectResponse(response, injectedDocument);
    }
}

function handleBlobResponse(response, injectedDocument) {
    if (response.ok) {
        return response.blob().then(function (blob) {
            return Promise.resolve(blob);
        });
    } else {
        return rejectResponse(response, injectedDocument);
    }
}

function handleRawResponse(response, injectedDocument) {
    if (response.ok) {
        return Promise.resolve(response);
    } else {
        return rejectResponse(response, injectedDocument);
    }
}

function authenticatedFetch(requestUrl) {
    var requestObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var injectedFetch = arguments[2];
    var injectedDocument = arguments[3];

    validateFetch(injectedFetch);
    validateDocument(injectedDocument);

    requestObject = enrichRequestObject(requestObject);
    requestObject = parseRequestObjectBody(requestObject);

    return injectedFetch(requestUrl, requestObject).then(function (response) {
        return handleTextResponse(response, injectedDocument);
    });
}

function authenticatedFetchRaw(requestUrl) {
    var requestObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var injectedFetch = arguments[2];
    var injectedDocument = arguments[3];

    validateFetch(injectedFetch);
    validateDocument(injectedDocument);

    requestObject = enrichRequestObject(requestObject);
    requestObject = parseRequestObjectBody(requestObject);

    return injectedFetch(requestUrl, requestObject).then(function (response) {
        return handleRawResponse(response, injectedDocument);
    });
}

function unauthenticatedFetchRaw(requestUrl) {
    var requestObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var injectedFetch = arguments[2];
    var injectedDocument = arguments[3];

    validateFetch(injectedFetch);
    validateDocument(injectedDocument);

    requestObject = fixRequestObject(requestObject);
    requestObject = parseRequestObjectBody(requestObject);

    return injectedFetch(requestUrl, requestObject).then(function (response) {
        return handleRawResponse(response, injectedDocument);
    });
}

function authenticatedFetchBlob(requestUrl) {
    var requestObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var injectedFetch = arguments[2];
    var injectedDocument = arguments[3];

    validateFetch(injectedFetch);
    validateDocument(injectedDocument);

    requestObject = enrichRequestObject(requestObject);
    requestObject = parseRequestObjectBody(requestObject);

    return injectedFetch(requestUrl, requestObject).then(function (response) {
        return handleBlobResponse(response, injectedDocument);
    });
}

function authenticatedFetchJSON(requestUrl) {
    var requestObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var injectedFetch = arguments[2];
    var injectedDocument = arguments[3];

    validateFetch(injectedFetch);
    validateDocument(injectedDocument);

    if (!requestObject.headers) {
        requestObject.headers = {};
    }

    requestObject.headers.Accept = 'application/json';

    requestObject = parseRequestObjectBody(requestObject);

    return authenticatedFetch(requestUrl, requestObject, injectedFetch, injectedDocument).then(function (response) {
        try {
            if (!response) {
                return Promise.resolve({});
            }

            var parsedResult = JSON.parse(response);
            return Promise.resolve(parsedResult);
        } catch (parseError) {
            return Promise.reject(new ParseResponseError(parseError.message, response, requestUrl));
        }
    });
}

function getAuthenticatedFetchBlob() {
    var injectedFetch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fetch;
    var injectedDocument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

    validateFetch(injectedFetch);
    validateDocument(injectedDocument);

    return function (requestUrl, requestObject) {
        return authenticatedFetchBlob(requestUrl, requestObject, injectedFetch, injectedDocument);
    };
}

function getAuthenticatedFetchJSON() {
    var injectedFetch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fetch;
    var injectedDocument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

    validateFetch(injectedFetch);
    validateDocument(injectedDocument);

    return function (requestUrl, requestObject) {
        return authenticatedFetchJSON(requestUrl, requestObject, injectedFetch, injectedDocument);
    };
}

function getAuthenticatedFetch() {
    var injectedFetch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fetch;
    var injectedDocument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

    validateFetch(injectedFetch);
    validateDocument(injectedDocument);

    return function (requestUrl, requestObject) {
        return authenticatedFetch(requestUrl, requestObject, injectedFetch, injectedDocument);
    };
}

function getAuthenticatedFetchRaw() {
    var injectedFetch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fetch;
    var injectedDocument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

    validateFetch(injectedFetch);
    validateDocument(injectedDocument);

    return function (requestUrl, requestObject) {
        return authenticatedFetchRaw(requestUrl, requestObject, injectedFetch, injectedDocument);
    };
}

function getUnauthenticatedFetchRaw() {
    var injectedFetch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fetch;
    var injectedDocument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

    validateFetch(injectedFetch);
    validateDocument(injectedDocument);

    return function (requestUrl, requestObject) {
        return unauthenticatedFetchRaw(requestUrl, requestObject, injectedFetch, injectedDocument);
    };
}

function polyfillCustomEvent() {
    var injectedWindow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;


    if (typeof injectedWindow.CustomEvent === 'function') {
        return false;
    }

    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = injectedWindow.Event.prototype;

    injectedWindow.CustomEvent = CustomEvent;
}

polyfillCustomEvent();
